import RedesignDescriptor from './referral-redesign';
import RefiveDescriptor from './referral-refive';
import CanteenDescriptor from './referral-canteen';
import CompanyKitchenDescriptor from './refferal-companykitchen';
import AramarkDescriptor from './referral-aramark';
import Settings from 'src/Settings';
import {BuildTypeEnum} from 'src/constants/BuildTypeEnum';

const typeDescriber = {
  [BuildTypeEnum.aramark]: AramarkDescriptor,
  [BuildTypeEnum.canteen]: CanteenDescriptor,
  [BuildTypeEnum.default]: RedesignDescriptor,
  [BuildTypeEnum.companykitchen]: CompanyKitchenDescriptor,
  [BuildTypeEnum.refive]: RefiveDescriptor,
};

export function getDescriber() {
  return typeDescriber[Settings.buildType as keyof typeof typeDescriber];
}
